import React, { useEffect, useState } from "react";
import { Page, LoadingMsg } from "components/common";
import { Row, Col, Button, ModalFooter, Modal } from "reactstrap";
import { FormGroup } from "components/common/Forms";
import { Trans, useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { LocalForm, Control } from "react-redux-form";
import { ApiClient } from "services";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

  const colStyle = {
    xs: false,
    md: 6,
    className: "pt-1 pb-1"
  }

  const colStyle2 = {
    xs: false,
    md: 6,
    className: "pt-3 pb-1"
  }

  const headerStyle = {
    style:{fontSize: '1.4em'},
    className: "text-center"
  }

  const lightGrey = {
    style:{backgroundColor: "#fefefe", color: "#333"},
    className:"mb-4 alert alert-secondary pr-5 pt-3 mt-2",
    role:"alert"}
  
export const RegisterUser = ({dataPresent = false, item, handleClose, show}) => {

const client = ApiClient()
const history = useHistory();
const {t} = useTranslation()  

const [isSending, setIsSending] = useState(false);
const [loading, setLoading] = useState(false);

const fetchData = async () => {
    setLoading(true)
    try {
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const mainHome = () => {
    history.push(`/register`)
  };


const handleSave = (values) => {
    setIsSending(true)

    console.log(values, "valll")
    client.post(`/register`, values)
      .then(response => {
          console.log("Server response:", response.data);
          NotificationManager.success(t('Application Added Successfully.'));
          setIsSending(false);
          //setTimeout(() => {
            //history.push("/developers/apps");
         // }, 1500);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const errorMessage = `${key.charAt(0).toUpperCase() + key.slice(1)} - ${value}`;
            NotificationManager.error(errorMessage);
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  };

  return (
    <Modal isOpen={show} toggle={handleClose}>
    <Page showTitle={false} title={t("Register User")}>
      <div className="d-flex justify-content-center align-items-center">
      {loading ? (
        <LoadingMsg />
      ) : (
      <>
       <div style={{maxWidth:"70%"}}>
        <div {...lightGrey}>
        <div className="text-center"><span {...headerStyle}>Register A New Account</span></div>
        <ul className="py-4">
         <li>
          <LocalForm initialState={item} onSubmit={values => handleSave(values)}>
          {!dataPresent && 
          <div>
          <Row>
            <Col {...colStyle}>
              <FormGroup model=".first_name">
                <Control.text placeholder={t("First Name")} model=".first_name"/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup model=".last_name">
                <Control.text placeholder={t("Last Name")} model=".last_name"/>
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup model=".email">
                <Control.text placeholder={t("Email Address")} model=".email" />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup model=".reference">
                <Control.text placeholder={t("Reference")} model=".reference" />
              </FormGroup>
            </Col>
          </Row>
          <div>Password:</div>
          <Row>
          <Col {...colStyle2}>
                <FormGroup>
                  <Control.text
                    type="password"
                    model=".password"
                    className="rounded mb-0"
                    placeholder={t("Password")}
                  />
                </FormGroup>
            </Col>
            <Col {...colStyle2}>
                <FormGroup>
                  <Control.text
                    type="password"
                    model=".confirm_password"
                    className="rounded mb-0"
                    placeholder={t("Confirm Password")}
                  />
                </FormGroup>
            </Col>

          </Row>
          </div>
          }
          <div className="tw-flex my-4">
          <Button color="primary" onClick={mainHome} className="mx-0 w-50"><Trans>Go To Company Register</Trans></Button>
          <Button className="w-20"/>
          {!isSending ? (
            <Button className="mx-0 w-50"><Trans>Submit</Trans></Button>
            ):(
            <Button className="mx-0 w-50" disabled><span className="fa fa-spinner fa-spin"/> <Trans>Registering</Trans></Button>
          )}
          </div>
        </LocalForm>
       </li>
      </ul>
      </div>
    </div>
    </>
    )}
    </div>
    </Page>
    <ModalFooter>
        <Button color="secondary" onClick={handleClose}><Trans>Close</Trans></Button>
    </ModalFooter>
    </Modal>
  );
};


export default RegisterUser;